<script setup lang="ts">
import {
  computed,
} from 'vue';

import type { IFormPlainDataListboxPropsChangeState } from '@modules/forms/types';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import VFormPlainDataListbox from '@modules/forms/components/inputs/VFormPlainDataListbox/VFormPlainDataListbox.vue';

import type { ISettingsPaymentSystemsPayload } from '../../types';
import {
  ADMIN_PAYMENT_SYSTEMS_PERMISSIONS,
  TRANSLATION_GROUP_GENERAL_SETTINGS_PAYMENT_SYSTEMS,
} from '../../constants';
import {
  useSettingsPaymentSystemsAddMutation,
  useSettingsPaymentSystemsRemoveMutation,
} from '../../mutations';
import { useSettingsPaymentSystemsListQuery } from '../../queries';
import PaymentCountryGroupsList from '../../submodules/country-groups/components/PaymentCountryGroupsList/PaymentCountryGroupsList.vue';

const { data, isLoading } = useSettingsPaymentSystemsListQuery();
const { mutateAsync: addField, isLoading: isAddFieldLoading } = useSettingsPaymentSystemsAddMutation();
const { mutateAsync: removeField, isLoading: isRemoveFieldLoading } = useSettingsPaymentSystemsRemoveMutation();

const options = computed(() => data.value?.payment_systems ?? []);

function onChange(state: IFormPlainDataListboxPropsChangeState<string>): void {
  const { check, values, ...payment_system } = state;

  const payloadObject: ISettingsPaymentSystemsPayload = {
    payment_system,
  };

  if (check) {
    void addField(payloadObject);
  } else {
    void removeField(payloadObject);
  }
}
</script>

<template>
  <VCard v-data-qa-auto-id="'AdminAvailablePaymentSystemsPage'"
    type="form"
    :title="$getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_PAYMENT_SYSTEMS, 'HEADER')"
    class="mb-4"
  >
    <VLoader
      :loading="isLoading"
      min-height="350px"
    >
      <VFormPlainDataListbox
        :label="$getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_PAYMENT_SYSTEMS, 'LABEL')"
        :data="options"
        :disabled="!$hasPermission(ADMIN_PAYMENT_SYSTEMS_PERMISSIONS.PAYMENTSYSTEMLISTS_UPDATE) || isAddFieldLoading || isRemoveFieldLoading"
        @change="onChange"
      />
    </VLoader>
  </VCard>
  <PaymentCountryGroupsList />
</template>
